import React from "react";
import { FaInbox } from "react-icons/fa";

function EmptyState({ icon, title, message, subMessage }) {
  return (
    <div className="flex flex-col items-center gap-1 py-6 text-center">
      <div className="mb-1 text-slate-300">{icon || <FaInbox size={20} />}</div>
      {title && <p className="text-sm font-medium text-slate-600">{title}</p>}
      <p className="text-xs text-slate-400">{message}</p>
      {subMessage && <p className="text-[11px] text-slate-300">{subMessage}</p>}
    </div>
  );
}

export default EmptyState;